import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

// import {Layout} from "../../core/layout";
// import {PartMenuType} from "../../constants";
import SelectionMobileViewSwitchers from '../mobile/selectionMobileViewSwitchers';
import BodyPanelRadio from "./bodyPanelRadio";
import BodyPanelCheckbox from "./bodyPanelCheckbox";
import BodyPanelWizardSteps from "./bodyPanelWizardSteps";
// import Analytics from "../../../../analytics";
import FilterSwitchers from "../newFilters/filterSwitchers";
import BodyPanelNavigationFiltersSteps from "./bodyPanelNavigationFiltersSteps";
import BacksplashSelect from "../../../selectionWindow/backsplashSelect";
import {CABINET_GROUP, COUNTERTOP_GROUP} from "../../../kvComponent/core/constants";
import CountertopSwitchers from "../../../kvComponent/navigation/countertopSwitchers";
import CabinetSwitchers from "../../../kvComponent/navigation/cabinetSwitchers";
import {CABINET_GROUP_BATHROOM, COUNTERTOP_GROUP_BATHROOM} from "../../../bvSceneComponent/core/constants";
import LookAllWallsRadioButton from "../../../look/lookNavigation/lookMain/lookAllWallsRadioButton";
import {getCurrentLayout} from "../../../appLayout";
import {featureInterface} from "../../../../interfaces/featureInterface";

class BodyPanel extends Component {

  static propTypes = {
    // layout: PropTypes.instanceOf(Layout),
    activePart: PropTypes.object.isRequired,
    activeSubPart: PropTypes.object,
    activeFeature: PropTypes.shape(featureInterface),
    toggleApplyWallsCheckbox: PropTypes.func,
    isWallItem: PropTypes.func,
    handleSubTypeClick: PropTypes.func,
    useWizard: PropTypes.bool,
    showFeatureWizard: PropTypes.bool,
    exitFeatureWizard: PropTypes.func,
    enableFeatureWizard: PropTypes.func,
    wizardGroups: PropTypes.array,
    filters: PropTypes.array,
    getFilterDisplayName: PropTypes.func.isRequired,
    toggleWizardFilterSelection: PropTypes.func,
    refreshCB: PropTypes.func,
    showFilterSelection: PropTypes.bool,
    showWizardGroupsSelection: PropTypes.bool,
    setStateActiveFeature: PropTypes.func,
  };

  backsplashSelectClick = (feature) => {
    this.props.refreshCB(); // update canvas
    this.props.refreshItems(); // update nav items
    if (this.props.setStateActiveFeature) {
      this.props.setStateActiveFeature(feature);
    }
  };

  renderAllWallsCheckbox = (showFilterSelection) => {
    const layout = getCurrentLayout();
    if (layout.isNewLayout) {
      return <LookAllWallsRadioButton lookFeature={this.props.activeFeature}/>
    } else if (!showFilterSelection && this.props.activeSubPart && this.props.isWallItem(this.props.activeSubPart)
      && this.props.activeSubPart.partName !== "Accent Wall") {
      return <BodyPanelCheckbox activeSubPart={this.props.activeSubPart}
                                toggleApplyWallsCheckbox={this.props.toggleApplyWallsCheckbox}/>
    }
    return null
  }

  render() {

    const showFilterSelection = this.props.showFilterSelection || this.props.showWizardGroupsSelection;
    const activeNavPart = this.props.activeSubPart || this.props.activePart;

    const fabricatorSettings = this.props.fabricatorData.settings;
    const useWizard = fabricatorSettings &&
      (fabricatorSettings.wizardConsumers || (fabricatorSettings.wizardClients && document.kvConfig.isBackend));

    let showNavigationFilters = useWizard && this.props.activeNavigationFilter
      && (this.props.activeNavigationFilter !== "inlay_type") && activeNavPart
      && activeNavPart.canUseNavigationFilter && activeNavPart.canUseNavigationFilter();

    if (useWizard && activeNavPart && activeNavPart.canUseNavigationFilterSteps
      && activeNavPart.canUseNavigationFilterSteps()) {
      showNavigationFilters = true;
    }

    const isCountertop = this.props.activeSubPart && (
      COUNTERTOP_GROUP.includes(this.props.activeSubPart.partId)
      || ((document.kvConfig.visualizerType === "bvScene" || document.kvConfig.visualizerType === "Bathroom")
        && COUNTERTOP_GROUP_BATHROOM.includes(this.props.activeSubPart.partId))
    );

    const isCabinet = this.props.activeSubPart && (CABINET_GROUP.includes(this.props.activeSubPart.partId)
      || (document.kvConfig.visualizerType === "bvScene" && CABINET_GROUP_BATHROOM.includes(this.props.activeSubPart.partId)));

    const layout = getCurrentLayout();

    return (
      <div className={"panel" + (this.props.useWizard || this.props.useFilters || showNavigationFilters
        ? " panel--inline" : "")}>
        <h3 className="panel-title">{activeNavPart ? <FormattedMessage id={activeNavPart.translateId}/> : null}</h3>
        <div className="panel-switcher">
          {!showFilterSelection && this.props.activeSubPart && this.props.activeSubPart.canBeDisabled
            ? <BodyPanelRadio activeSubPart={this.props.activeSubPart} refreshItems={this.props.refreshItems}/>
            : null}
          {this.renderAllWallsCheckbox(showFilterSelection)}
        </div>
        {/*{this.props.activePart.menuType === PartMenuType.Complex && this.props.activePart.subTypes().length && !showFilterSelection*/}
        {/*  ? (*/}
        {/*    <div className="panel-switcher">*/}
        {/*      <div className="menu-body__top-subtypes">*/}
        {/*        {this.props.activePart.subTypes().map(subType => (*/}
        {/*          <button className={"menu-body__top-subtypes-button"*/}
        {/*          + (this.props.activePart.activeSubType() === subType ? " menu-body__top-subtypes-button--active" :"")}*/}
        {/*                  onClick={() => Analytics.sendClickEvent('sub-type-clicked-' + subType) && this.props.handleSubTypeClick(subType)}*/}
        {/*                  key={subType}>*/}
        {/*            {this.props.activePart.subTypeToString(subType) || subType}*/}
        {/*          </button>*/}
        {/*        ))}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  ) : null}*/}
        {!showFilterSelection ? (
          <div className="panel-view">
            <SelectionMobileViewSwitchers switchers={[2,3]}/>
          </div>
        ) : null}
        {this.props.useWizard && !this.props.showWizardGroupsSelection ? (
          <BodyPanelWizardSteps availableSteps={this.props.showFeatureWizard ? this.props.availableSteps : this.props.wizardGroups}
                                featureWizardStep={this.props.featureWizardStep}
                                setFeatureWizardStep={this.props.setFeatureWizardStep}
                                getFilterDisplayName={this.props.getFilterDisplayName}
                                exitFeatureWizard={this.props.exitFeatureWizard}
                                enableFeatureWizard={this.props.enableFeatureWizard}
                                showFeatureWizard={this.props.showFeatureWizard}
                                activeSubPart={this.props.activeSubPart}
                                toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
          />
        ) : null}
        {activeNavPart.partId === "backsplash" ? <BacksplashSelect  updateParent={this.backsplashSelectClick}/> : null}
        {isCountertop && !layout.isNewLayout ? <CountertopSwitchers showAsDropdown={true}
                                                                    isMaterials={true}
                                                                    activeSubPart={this.props.activeSubPart}/> : null}
        {isCabinet && !layout.isNewLayout ? <CabinetSwitchers showAsDropdown={true}
                                                              activeSubPart={this.props.activeSubPart}/> : null}
        {showNavigationFilters ? (
          <BodyPanelNavigationFiltersSteps activePart={activeNavPart}/>
        ) : null}
        {this.props.useFilters && !showFilterSelection ? (
          <FilterSwitchers activePart={activeNavPart} filterGroupName="Material"/>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    fabricatorData: store.fabricatorState,
  };
};
const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(BodyPanel);
